import {
    InvoiceRequestParams,
    GenerationIrnParams,
    InvoicePageResponse,
} from '@entities/invoices/types';
import {FetchInvoiceDetailResponse} from '@nds-taxpayers/create-invoice-new/src/ports';
import api from '@shared/api';

const PATH = 'invoice-api/api/v2/invoices';
export const fetch = async (payload: InvoiceRequestParams) =>
    (await api.post<InvoicePageResponse>(`${PATH}/page`, payload)).data;

export const generateIrn = async (params: GenerationIrnParams) =>
    (await api.get<string>(`${PATH}/generation-irn`, {params})).data;

export const fetchBody = async ({id, tin}: {id: string; tin?: string}) =>
    (await api.get<FetchInvoiceDetailResponse>(`${PATH}/body-tin`, {params: {id, tin}})).data;
